import { useMemo, useState } from 'react';
import { Backdrop, Box, Fab, SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material';

import { useAppSelector } from '../../utils/hooks';
import { speedDialButtonSelector } from '../../store/selectors';

export default function AppSpeedDial() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const speedDialButton = useAppSelector(speedDialButtonSelector);

  const buttonContent = useMemo(() => speedDialButton, [speedDialButton]);

  return (
    <Box
      sx={{
        bottom: '16px',
        right: '16px',
        zIndex: 999,
        transform: 'translateZ(0px)',
        flexGrow: 1,
        position: 'absolute',
      }}
    >
      {buttonContent.length ? (
        buttonContent.length > 1 ? (
          <>
            <Backdrop open={open} />
            <SpeedDial
              ariaLabel="SpeedDial tooltip example"
              sx={{ position: 'absolute', bottom: 16, right: 16 }}
              icon={<SpeedDialIcon />}
              onClose={handleClose}
              onOpen={handleOpen}
              open={open}
            >
              {buttonContent?.map((action, index) => (
                <SpeedDialAction
                  key={index}
                  // key={action.name}
                  icon={action.icon}
                  tooltipTitle={action.name}
                  tooltipOpen={!!action.name}
                  onClick={() => {
                    action.onClick();
                    handleClose();
                  }}
                />
              ))}
            </SpeedDial>
          </>
        ) : (
          buttonContent?.map((action, index) => {
            return (
              <Fab
                key={index}
                // key={action.name}
                sx={{ position: 'absolute', bottom: 16, right: 16 }}
                color="primary"
                onClick={() => {
                  action.onClick();
                  handleClose();
                }}
                disabled={action.disabled}
              >
                {action.icon}
              </Fab>
            );
          })
        )
      ) : undefined}
    </Box>
  );
}
